module.exports = __webpack_public_path__ + "vn.svg?be36edc23db257236d8d17040b365ffc";